import { PocIcon } from 'commons/components/components-wrapper';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { SearchableDropdownInput } from '../searchable-dropdown.style';
import { keepTextEditingKeysInInput } from '../searchable-dropdown.utils';

type SearchableDropdownDefaultSearchInputProps = {
    filter: string;
    placeholder?: string;
    setFilter: (newValue: string) => void;
};

export const SearchableDropdownDefaultSearchInput: React.FC<SearchableDropdownDefaultSearchInputProps> = (props) => {
    const { filter, setFilter, placeholder = 'commons.components.searchable-dropdown.search.placeholder' } = props;

    const { t } = useTranslation();

    return (
        <SearchableDropdownInput
            autoFocus
            value={filter}
            placeholder={t(placeholder)}
            onValueChange={(ev) => setFilter(ev.detail)}
            variant="outlined"
            size="small"
            nativeInputProps={{
                onkeydown: keepTextEditingKeysInInput,
            }}
        >
            <PocIcon slot="prefix" name="search" family="outlined" />
        </SearchableDropdownInput>
    );
};
